import { render, staticRenderFns } from "./ReportDataPublicationView.vue?vue&type=template&id=f104191a&scoped=true&"
import script from "./ReportDataPublicationView.vue?vue&type=script&lang=ts&"
export * from "./ReportDataPublicationView.vue?vue&type=script&lang=ts&"
import style0 from "./ReportDataPublicationView.vue?vue&type=style&index=0&id=f104191a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f104191a",
  null
  
)

export default component.exports